import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { ContentModel } from "@tecumseh/Services/PIMExportHistoryService";
import { ApiResultTemplateListModel } from "@tecumseh/Services/PIMGetTemplateListService";
import { Draft } from "immer";

export interface APIResultPimCustomerTemplateModel extends ApiResultTemplateListModel{
    isLoading: boolean;
}

const initialState: APIResultPimCustomerTemplateModel = {
    templateList: [],
    isLoading: false
};

const reducer = {
    "Custom/PIMGetTemplateList/startLoading": (draft: Draft<APIResultPimCustomerTemplateModel>, action: { contentResults: any  }) => {
            draft.isLoading = true;
        },
    "Custom/PIMGetTemplateList/SetContents": (draft: Draft<APIResultPimCustomerTemplateModel>, action: { contentResults: any }) => {
        draft.templateList = JSON.parse(action.contentResults);
        draft.isLoading = false;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
